import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable, tap } from 'rxjs';
import { ProjectResponse } from '../../../core/models/projects-unit-test-response';
import { SubmitTaskResponse } from '../../../core/models/submit-task-response';
import { AuthService } from '../../../core/auth/services/auth.service';
import { BuildInfo } from '../../../core/models/build-info';

@Injectable({
  providedIn: 'root'
})
export class UnitTestService {

  private testUnitResource = 'ms-unittest';
  private readonly apiTestUnits: string;
  constructor(private http: HttpClient, private authService: AuthService) {
    this.apiTestUnits = `${environment.unittestsApiUrl}`;
  }

  uploadZip(file: File, projectId: string): Observable<any> {
    const headers = {
      'user-id': 'user1'
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId);
    return this.http.post<any>(`${this.apiTestUnits}/projects/upload`, formData, { headers }).pipe(
      tap(response => {
      })
    );
  }

  getProjects(): Observable<ProjectResponse[]> {
    const headers = {
      'user-id': 'user1'
    }
    return this.http.get<ProjectResponse[]>(`${this.apiTestUnits}/projects`, { headers });
  }

  getTree(projectId: string): Observable<string[]> {
    const headers = {
      'user-id': 'user1'
    }
    return this.http.get<string[]>(`${this.apiTestUnits}/projects/${projectId}/tree`, { headers });
  }

  getFileInfo(projectId: string, qualifiedNames: string[]): Observable<any> {
    const headers = {
      'user-id': 'user1'
    }
    return this.http.post<any>(`${this.apiTestUnits}/projects/${projectId}/files`, qualifiedNames, { headers });
  }

  generateTest(
    token: string,
    projectId: string,
    iaModel: string,
    classSelections: any[],
    unitTestId: string,
    projectType: string = 'JAVA',
    testFramework: string | null = null,
    buildInfo?: BuildInfo
  ): Observable<SubmitTaskResponse> {
    const headers = {
      'user-id': 'user1',
      'Content-Type': 'application/json',
      'X-Genai-Bearer': token,
    }
    const body: any = {
      unitTestId: unitTestId,
      criteriaId: iaModel,
      classSelections: classSelections,
      projectType: projectType,
    };

    if (testFramework) {
      body.testFramework = testFramework;
    }
    if (buildInfo) {
      body.buildInfo = buildInfo;
    }
    return this.http.post<SubmitTaskResponse>(`${this.apiTestUnits}/projects/${projectId}/classtest/generateTest`, body, { headers });
  }

  getBuildInfo(projectId: string): Observable<BuildInfo> {
    const headers = {
      'user-id': 'user1'
    }
    return this.http.get<BuildInfo>(`${this.apiTestUnits}/projects/${projectId}/build-info`, { headers });
  }

  getResultFromCompleted(taskId: string): Observable<any> {
    const headers = {
      'user-id': 'user1'
    }
    return this.http.get<any>(`${this.apiTestUnits}/tasks/${taskId}/result`, { headers });
  }

  stop(taskId: string): Observable<boolean>{
    return this.http.post<boolean>(`${this.apiTestUnits}/stop`, {taskId});
  }

}
